// client/src/components/Landing.js
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { APP_LOGO_SRC, APP_NAME } from '../config/branding'
import LegalFooter from './common/LegalFooter'
import { track } from '../analytics'
import LeagueInfoSection from './leagues/LeagueInfoSection'
import './Landing.css'

function Landing() {
  const navigate = useNavigate()
  const [leagueInfoCollapsed, setLeagueInfoCollapsed] = useState(() => {
    // Initialize state from localStorage on first render only
    try {
      const storageKey = 'servesync_landing_info_seen'
      const hasVisited = localStorage.getItem(storageKey)
      return hasVisited === 'true' // Collapsed if they've visited before
    } catch (error) {
      console.warn('Could not check landing visit status:', error)
      return false // Default to expanded if we can't check
    }
  })

  // Track landing page view on mount
  useEffect(() => {
    track('page.landing_view', {
      page: '/landing',
      source: 'direct',
    })
  }, [])

  // Set localStorage flag after first render (only once)
  useEffect(() => {
    const storageKey = 'servesync_landing_info_seen'

    try {
      const hasVisited = localStorage.getItem(storageKey)
      if (hasVisited !== 'true') {
        localStorage.setItem(storageKey, 'true')
      }
    } catch (error) {
      console.warn('Could not save landing visit status:', error)
    }
  }, [])

  const handleSignIn = () => {
    navigate('/sign-in')
  }

  const handleSignUp = () => {
    navigate('/sign-up')
  }

  return (
    <div className="landing-container">
      <div className="landing-hero">
        <h1 className="landing-title">{APP_NAME}</h1>

        <img
          src={APP_LOGO_SRC}
          alt="Serve Sync Tennis logo"
          className="tennis-hero-image"
        />

        <div className="landing-buttons">
          <button
            onClick={handleSignUp}
            className="landing-btn landing-btn-primary"
            type="button"
            data-track="navigation.signup"
          >
            Join Now
          </button>
          <button
            onClick={handleSignIn}
            className="landing-btn landing-btn-secondary"
            type="button"
            data-track="navigation.signin"
          >
            Sign In
          </button>
        </div>

        <section className="landing-about" aria-label="About ServeSync">
          <h2 className="landing-about-title">How ServeSync Works</h2>
          <p className="landing-about-text">
            ServeSync is a platform for tennis league participants to coordinate
            matches and track schedules.
          </p>
          <p className="landing-about-text">
            Registered players can proactively opt-in via their private account
            settings to receive automated SMS match reminders and scheduling
            updates.
          </p>
        </section>

        {/* Inline League Info Section - Always visible, collapsed for returning visitors */}
        <div className="landing-info-section-wrapper">
          <LeagueInfoSection
            collapsed={leagueInfoCollapsed}
            onToggle={(collapsed) => {
              setLeagueInfoCollapsed(collapsed)
            }}
          />
        </div>

        <LegalFooter />
      </div>
    </div>
  )
}

export default Landing
